import PageMeta from '@/components/base/PageMeta';
import { Link } from 'react-router-dom';
import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const brandValues = [
    { icon: 'ri-vip-crown-line', title: '永久免费', desc: '我们承诺所有漫画内容永久免费，让每一位漫画爱好者都能无负担地享受阅读乐趣' },
    { icon: 'ri-scroll-to-bottom-line', title: '下拉体验', desc: '专为移动端优化的下拉式阅读模式，单手操作即可流畅阅读，告别繁琐翻页' },
    { icon: 'ri-shield-check-line', title: '正版合作', desc: '与多家韩国漫画平台建立合作关系，推动韩漫内容的正版化传播' },
    { icon: 'ri-group-line', title: '社区氛围', desc: '打造温馨友好的漫画爱好者社区，让读者可以自由交流和分享阅读心得' },
  ];

  const brandStats = [
    { value: '2020年', label: '成立时间' },
    { value: '30,000+', label: '漫画资源' },
    { value: '500万+', label: '日活跃用户' },
    { value: '50+国家', label: '覆盖范围' },
  ];

  const honors: { title: string; description: string; icon: string; bg?: string; bgImage?: string }[] = [
    {
      title: '免费承诺',
      description: '自成立以来，我们始终坚持免费提供韩漫阅读服务，让优质内容无障碍传播',
      icon: 'ri-heart-line',
      bg: 'bg-foreground-950',
    },
    {
      title: '正版授权',
      description: '与韩国多家漫画平台达成合作，拥有正版漫画授权，确保内容质量',
      icon: 'ri-verified-badge-line',
      bg: 'relative',
      bgImage: 'https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20Korean%20manhwa%20studio%20with%20drawing%20tablets%20and%20comic%20pages%20on%20desk%2C%20creative%20workspace%2C%20warm%20lighting%2C%20artistic%20atmosphere%2C%20professional%20yet%20cozy%20vibe&width=800&height=500&seq=about-honor-license&orientation=landscape',
    },
    {
      title: '行业认可',
      description: '获得多项漫画行业大奖，被多家媒体评为"最佳韩漫阅读平台"',
      icon: 'ri-award-line',
    },
  ];

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '非麻瓜漫画',
      url: 'http://wa25w.cn/',
      description: '非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。',
      foundingDate: '2020',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@wa25w.cn',
        contactType: 'customer service',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '关于非麻瓜漫画 - 免费韩漫阅读平台',
      description: '了解非麻瓜漫画的品牌故事、平台优势和联系方式。致力于为华语用户提供最优质的免费韩国漫画阅读体验。',
      url: 'http://wa25w.cn/about',
      inLanguage: 'zh-CN',
    },
  ];

  return (
    <>
      <PageMeta
        title="关于我们 - 非麻瓜漫画_免费韩漫在线阅读平台"
        description="了解非麻瓜漫画的品牌故事、平台优势和联系方式。致力于为华语用户提供最优质的免费韩国漫画阅读体验，拥有30000+漫画资源，每日更新。"
        keywords="非麻瓜漫画,关于非麻瓜,韩漫平台介绍,免费漫画网站,漫画品牌故事"
        canonicalUrl="http://wa25w.cn/about"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main className="pt-16">
        <section className="relative w-full min-h-[350px] md:min-h-[420px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20comic%20reading%20space%20with%20bookshelves%20filled%20with%20colorful%20comics%2C%20soft%20warm%20lighting%2C%20comfortable%20reading%20chairs%2C%20artistic%20Korean%20manhwa%20aesthetic%2C%20community%20and%20sharing%20vibe&width=1920&height=700&seq=about-hero-brand&orientation=landscape"
            alt="关于非麻瓜漫画 - 品牌介绍"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
            <Breadcrumb
              items={[
                { name: '首页', url: '/' },
                { name: '关于我们', url: '/about' },
              ]}
            />
            <div className="mt-6 flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-3/5 text-center lg:text-left">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
                  关于
                  <span className="block mt-1 text-primary-400">非麻瓜漫画</span>
                </h1>
                <p className="mt-4 text-sm md:text-base text-background-200/80 max-w-lg mx-auto lg:mx-0 leading-relaxed">
                  非麻瓜漫画成立于2020年，致力于为华语用户提供最优质的免费韩国漫画阅读体验。我们相信，好的内容不应该被付费墙阻隔。
                </p>
                <div className="mt-6">
                  <a href="#contact" className="px-7 py-3 border-2 border-background-50/40 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
                    联系我们
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-secondary-100">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 bg-background-50 text-foreground-700 text-xs font-medium rounded-full mb-3">
                品牌故事
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">我们是谁</h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                非麻瓜漫画诞生于一群韩漫爱好者的共同梦想。我们发现华语地区缺少一个真正优质的免费韩漫阅读平台，
                于是决心打造一个让所有人都能轻松享受韩漫的家园。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
              {brandValues.map((item) => (
                <div key={item.title} className="text-center p-5 bg-background-50 rounded-lg">
                  <span className="w-12 h-12 flex items-center justify-center mx-auto text-3xl text-primary-500">
                    <i className={item.icon}></i>
                  </span>
                  <h3 className="mt-3 text-base font-heading font-semibold text-foreground-900">{item.title}</h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              {brandStats.map((stat) => (
                <div key={stat.label} className="text-center p-5">
                  <p className="text-3xl md:text-4xl font-heading font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                荣誉与特色
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">我们的承诺</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="bg-foreground-950 rounded-lg p-6 md:p-7">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-700 mb-3">
                  <i className="ri-heart-line text-xl text-background-50"></i>
                </span>
                <h3 className="text-lg font-heading font-semibold text-background-50">{honors[0].title}</h3>
                <p className="mt-2 text-sm text-foreground-400 leading-relaxed">{honors[0].description}</p>
              </div>

              <div className="relative rounded-lg overflow-hidden p-6 md:p-7">
                {honors[1].bgImage && (
                  <img
                    src={honors[1].bgImage}
                    alt="正版授权"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                )}
                <div className="absolute inset-0 bg-foreground-950/70"></div>
                <div className="relative z-10">
                  <span className="inline-flex items-center gap-1 px-3 py-1 bg-accent-500/80 text-background-50 text-xs rounded-full whitespace-nowrap mb-3">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-verified-badge-line text-xs"></i>
                    </span>
                    正版授权
                  </span>
                  <h3 className="text-lg font-heading font-semibold text-background-50">{honors[1].title}</h3>
                  <p className="mt-2 text-sm text-background-300 leading-relaxed">{honors[1].description}</p>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6 md:p-7">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 mb-3">
                  <i className="ri-award-line text-xl text-foreground-600"></i>
                </span>
                <h3 className="text-lg font-heading font-semibold text-foreground-900">{honors[2].title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{honors[2].description}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 bg-foreground-800 text-foreground-200 text-xs font-medium rounded-full mb-3">
                读者心声
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">感谢每一位读者</h2>
            </div>

            <div className="max-w-2xl mx-auto">
              <div className="relative bg-foreground-900 rounded-lg p-7 md:p-9">
                <span className="text-5xl font-heading text-background-50/15 absolute top-4 left-5 leading-none">
                  &ldquo;
                </span>
                <p className="relative z-10 text-sm md:text-base text-foreground-200 leading-relaxed pt-4">
                  感谢每一位选择非麻瓜漫画的读者朋友。从最初几个人的小团队，到如今服务数百万漫画爱好者，
                  是你们的支持让我们不断前行。我们将继续坚持免费、优质的初心，为大家带来更多精彩的韩国漫画内容。
                  未来，我们期待与你一起成长，一起探索更多精彩的漫画世界！
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Friendly%20anime%20style%20character%20avatar%20with%20warm%20smile%2C%20gentle%20expression%2C%20simple%20background%2C%20professional%20yet%20approachable%2C%20chibi%20style&width=120&height=120&seq=about-founder-avatar&orientation=squarish"
                    alt="非麻瓜漫画团队"
                    className="w-10 h-10 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-medium text-background-50">非麻瓜漫画团队</p>
                    <p className="text-xs text-foreground-500">2026年7月</p>
                  </div>
                </div>
              </div>

              <div className="text-center mt-6">
                <button className="px-6 py-2.5 bg-accent-500/80 text-background-50 rounded-full text-sm font-medium hover:bg-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  查看更多评价
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="relative py-16 md:py-24 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20welcoming%20illustration%20of%20a%20community%20gathering%20space%20with%20people%20sharing%20and%20discussing%20comics%2C%20cozy%20cafe-like%20atmosphere%2C%20warm%20golden%20lighting%2C%20Korean%20manhwa%20aesthetic%2C%20friendly%20and%20inclusive%20vibe&width=1920&height=700&seq=about-cta-contact&orientation=landscape"
            alt="联系与合作"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center" id="contact">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50">与我们联系</h2>
            <p className="mt-3 text-sm md:text-base text-background-200/80 max-w-lg mx-auto leading-relaxed">
              无论是商务合作、内容授权还是用户反馈，我们都期待听到你的声音
            </p>

            <div className="mt-8 max-w-lg mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
              <div className="bg-background-50/10 backdrop-blur-sm rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center mx-auto text-xl text-primary-400">
                  <i className="ri-mail-line"></i>
                </span>
                <p className="mt-2 text-xs text-background-200/70">商务合作</p>
                <p className="text-sm text-background-50 font-medium">hello@wa25w.cn</p>
              </div>
              <div className="bg-background-50/10 backdrop-blur-sm rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center mx-auto text-xl text-primary-400">
                  <i className="ri-customer-service-line"></i>
                </span>
                <p className="mt-2 text-xs text-background-200/70">用户反馈</p>
                <p className="text-sm text-background-50 font-medium">hello@wa25w.cn</p>
              </div>
              <div className="bg-background-50/10 backdrop-blur-sm rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center mx-auto text-xl text-primary-400">
                  <i className="ri-group-line"></i>
                </span>
                <p className="mt-2 text-xs text-background-200/70">加入我们</p>
                <p className="text-sm text-background-50 font-medium">hello@wa25w.cn</p>
              </div>
            </div>

            <a
              href="mailto:hello@wa25w.cn"
              className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-base font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-send-line text-background-50 text-sm"></i>
                </span>
              </span>
              商务合作
              <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}